import React, { useRef } from "react";
import { Box } from "@mui/material";
import NumberInputField from "../NumberInputField";

const InvitationPassword = ({
	passCode,
	setPassCode
}: {
	passCode: string[];
	setPassCode: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
	const passCodeRef = useRef<HTMLInputElement[]>([]);

	const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
		const paste = e.clipboardData.getData("text").trim();

		// Only allow numbers
		if (!/^\d+$/.test(paste)) return;
		const pass = paste.split("");
		setPassCode(pass);

		e.preventDefault();
	};

	return (
		<Box mt={2} display={"flex"} gap={1} justifyContent={"center"}>
			{passCode.map((p, i) => (
				<NumberInputField
					key={i}
					value={p}
					autoFocus={i === 0}
					id={`pass-${i}`}
					inputRef={(element: HTMLInputElement) => (passCodeRef.current[i] = element)}
					inputProps={{
						maxLength: 1,
						inputMode: "numeric"
					}}
					variant="outlined"
					style={{ width: "40px" }}
					onPaste={i === 0 ? handlePaste : undefined}
					onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
						if (e.key === "Backspace") {
							e.preventDefault();

							setPassCode(prevState => {
								const list = [...prevState];
								list[i] = "";
								return list;
							});
							return passCodeRef.current[i - 1]?.focus();
						}

						// If key is digit 0-9
						if (/^[0-9]$/.test(e.key)) {
							e.preventDefault();

							setPassCode(prev => {
								const copy = [...prev];
								copy[i] = e.key;
								return copy;
							});

							if (i < passCode.length - 1) {
								passCodeRef.current[i + 1]?.focus();
							}
							return;
						}
					}}
				/>
			))}
		</Box>
	);
};

export default InvitationPassword;
